import Vue from 'vue'
import App from './App.vue'
import { router } from './router';
import store from './store';
import VeeValidate, { Validator }  from 'vee-validate';
import pl from "vee-validate/dist/locale/pl";
import 'bootstrap';
import VueSweetalert2 from 'vue-sweetalert2';

import './assets/styles.css';
import './assets/animate.min.css';
import './assets/tooltip.css';
import VueElementLoading from 'vue-element-loading';
import { library } from '@fortawesome/fontawesome-svg-core';
import {Tabs, Tab} from 'vue-tabs-component';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
import VueProgressiveImage from 'vue-progressive-image';
import {ClientTable, ServerTable} from 'vue-tables-2';
import ToggleButton from 'vue-js-toggle-button';
import VueCookies from 'vue-cookies';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faHome,
    faUser,
    faUserPlus,
    faSignInAlt,
    faSignOutAlt,
    faSync,
    faArrowLeft,
    faCog,
    faQuestion,
    faImage,
    faCheck,
    faTimes,
    faUsers,
    faPlus,
    faSitemap,
    faTrash,
    faTachometerAlt,
    faBullhorn,
    faPaintBrush,
    faFighterJet,
    faEdit,
    faArrowsAlt,
    faChartLine,
    faHandPointRight,
    faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt, faSync, faArrowLeft, faCog, faQuestion, faImage, faCheck, faTimes, faUsers, faPlus, faSitemap, faTrash, faTachometerAlt, faBullhorn, faPaintBrush, faFighterJet, faEdit, faArrowsAlt, faChartLine, faHandPointRight, faExclamationTriangle);

Vue.config.productionTip = false;

Validator.localize({ pl: pl });

window.vueTableLocalize = {
    count: "Pokazuje od {from} do {to} z {count} wszystkich rekordów|{count} rekordy|Jeden rekord",
    first: 'Pierwszy',
    last: 'Ostatni',
    filter: "Filtrowanie:",
    filterPlaceholder: "Wpisz szukaną frazę",
    limit: "Rekordów:",
    page: "Strona:",
    noResults: "Brak pasujących rekordów",
    filterBy: "Filtrowanie przez {column}",
    loading: 'Ładowanie...',
    defaultOption: 'Wybierz {column}',
    columns: 'Kolumny'
};

Vue.use(require('vue-moment'));
Vue.use(VeeValidate, { locale: "pl" });
Vue.use(VueSweetalert2);
Vue.use(VueProgressiveImage);
Vue.use(ClientTable, {options: {}, useVuex: false, theme: 'bootstrap4', swappables: {}});
Vue.use(ServerTable, {options: {}, useVuex: false, theme: 'bootstrap4', swappables: {}});
Vue.use(ToggleButton);
Vue.use(VueCookies);

Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-popover', VPopover);

Vue.component('tabs', Tabs);
Vue.component('tab', Tab);

Vue.component('ServerGroups', require('./components/ServerGroups.vue').default);
Vue.component('Refresh', require('./components/Refresh.vue').default);
Vue.component('Channel', require('./components/Channel.vue').default);
Vue.component('Client', require('./components/Client.vue').default);
Vue.component('SelectChannel', require('./components/SelectChannel.vue').default);
Vue.component('SelectOnline', require('./components/SelectOnline.vue').default);
Vue.component('SelectChannels', require('./components/SelectChannels.vue').default);
Vue.component('Loader', require('./components/Loader.vue').default);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('VueElementLoading', VueElementLoading);


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
